import { categories, productText } from "../../mock/recommendations";

export default function recommendationsLogic(
  apiData,
  recomQuantity,
  langChanged = false
) {
  let recommendations = [],
    contentData = apiData["content"],
    categoryCount = [],
    product = apiData["product"],
    contentRecommendations = [],
    levelRecommendations = [],
    recommendationSections = {
      cta: [],
      primary: [],
      fallback: [],
    };
  if (langChanged) {
    contentData.forEach(function (rec) {
      if (typeof categories[rec.category].headline) {
        rec.headline = categories[rec.category].headline;
        recommendations.push(rec);
      }
    });

    if (product) {
      let category = product.category;
      product.body = productText[category];
      product.headline = productText.headline;
      product.title = product.name;
      recommendations.push(product);
    }
  } else {
    if (typeof product !== "undefined" && typeof product.name !== "undefined") {
      try {
        if (
          typeof productText?.headline !== "undefined" &&
          typeof product?.verb !== "undefined"
        ) {
          let category = product.category;
          product.body = productText[category];
          product.headline = productText.headline;
          product.title = product.name;
          recommendations.push(product);
        }
      } catch (error) {
        console.log(error);
      }
    }

    if (contentData) {
      contentRecommendations = contentData;

      let recKey = contentRecommendations.length - 1;

      while (recKey >= 0) {
        let rec = contentRecommendations[recKey];

        // adding recommendation made for specific level
        // if (typeof rec.level !== "undefined" && rec.level.includes(level)) {
        try {
          rec.headline = categories[rec.category].headline;
          rec.priority = 1;
          levelRecommendations.push(rec);
        } catch (error) {
          console.log(error);
        }
        // }

        recKey -= 1;
      }

      // sort table setting an order cta - primary - fallback
      levelRecommendations.sort(sortByCategory);

      // remove dublicates prioritizing higher category
      let filteredRec = levelRecommendations.reduce((acc, e) => {
        const found = acc.find((x) => e.cta_url === x.cta_url);

        found ? found.priority++ : acc.push(e); // increment priority if exist

        return acc;
      }, []);

      // limiting recommendations for specific category
      Object.keys(filteredRec).forEach(function (resKey) {
        let res = filteredRec[resKey];

        // fallback, if custom category
        if (typeof categoryCount[res.category] === "undefined") {
          categoryCount[res.category] = 0;
        }

        if (
          typeof categories[res.category] !== "undefined" &&
          categoryCount[res.category] < categories[res.category].quantity
        ) {
          if (typeof categories[res.category].headline) {
            res.headline = categories[res.category].headline;
          }

          // unshift recommendations into 3 arrays by main category
          if (res.category === "cta") {
            recommendations.unshift(res);
          } else if (res.category === "fallback") {
            recommendationSections.fallback.unshift(res);
          } else {
            recommendationSections.primary.unshift(res);
          }

          // increment category counter
          categoryCount[res.category]++;
        }
      });

      // sorting both tables by priority
      recommendationSections.primary.sort(sortByPriority);
      recommendationSections.fallback.sort(sortByPriority);

      // marge created tables in fallback, primary order
      let recommendationsContent = recommendationSections.primary.concat(
        recommendationSections.fallback
      );

      let recommendationsContentSliced = recommendationsContent.slice(
        0,
        recomQuantity - recommendations.length
      );

      recommendations = recommendationsContentSliced.concat(recommendations);
    }
  }

  return recommendations;
}

function sortByPriority(a, b) {
  if (a.priority > b.priority) return -1;
  if (a.priority < b.priority) return 1;
  return 0;
}

function sortByCategory(a, b) {
  if (a.category === "fallback" || b.category === "cta") return 1;
  if (b.category === "fallback" || a.category === "cta") return -1;
  return a.url.localeCompare(b.url);
}
